module.exports = __webpack_public_path__ + "img/-LV54gJ0GLHBIzRvcTIj.e91b8f02.jpg";